import React from "react";
import { useNavigate } from "react-router-dom";
import errorimg from "./assets/404_character.webp";
const NotFound = () => {
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center">
        <div className="error_wrapper">
          <h1>404</h1>
          <h2><span>Oops!</span>  Page Not Found</h2>
          <p className="text-gray-500">The page you are looking for does not exist or has been moved.</p>
          <button
            onClick={handleGoBack}
            className="btn btn-warning"
          >
            Go Back Home
          </button>
        </div>
        <div className="error_imgs">
          <img src={errorimg} alt="" /> 
        </div>
      </div>
    </div>
  );
};
export default NotFound;
